<template>
  <div class="m-wrap m-wap wap-verify-logo">
    <Banner :seminarInfo="seminarInfo" />
    <!--<div class="logo">-->
    <!--<img src="../../assets/images/wap/logo.png" alt="" />-->
    <!--</div>-->
    <!--<div class="banner">-->
    <!--<img src="../../assets/images/wap/banner.png" alt="" />-->
    <!--</div>-->
    <div class="verify-content">
      <div class="verify width">
        <div
          class="tab-text"
          :style="{
            'letter-spacing': extras.verifyTitle.wordWidth + 'px',
            color:
              extras1.verifyTitle.verifyTitleTextStyle == 'custom'
                ? extras1.verifyTitle.fontColor
                : '',
            'font-style':
              extras1.verifyTitle.verifyTitleTextStyle == 'custom'
                ? extras1.verifyTitle.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              extras1.verifyTitle.verifyTitleTextStyle == 'custom'
                ? extras1.verifyTitle.fontWeight == 'on'
                  ? '900'
                  : ''
                : '',
          }"
          v-if="extras.verifyTitle.display == 1"
        >
          {{
            extras1.verifyTitle.verifyTitleTextStyle == "custom"
              ? extras1.verifyTitle.title
              : "身份验证"
          }}
        </div>
        <!--字段上下结构-->
        <div v-if="extraItem.extras('formfield.model') == 'style1'">
          <div class="tab-input">
            <div class="must style1-wap">
              <div class="u-label">
                {{ identityPlaceholder || identityPlaceholderDefault }}
              </div>
              <a-input
                v-model="identity"
                class="verify-input"
                :class="{ err: error.identityText }"
                :placeholder="identityPlaceholder || identityPlaceholderDefault"
              ></a-input>
              <div
                v-if="isShowPhoneTips"
                style="color: #cacaca; font-size: 3.2vw; margin-top: 1vw"
              >
                手机号请填写区号，如86
              </div>
              <div class="u-reg-err-tips">{{ error.identityText }}</div>
            </div>
          </div>
          <div
            class="tab-input"
            v-if="extras.verifySet"
            :style="{
              display:
                extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
            }"
          >
            <div class="must style1-wap">
              <div class="u-label">验证码</div>
              <div class="verify-con">
                <a-input
                  class="verify-input"
                  v-model="code"
                  :class="{ err: error.codeText }"
                  placeholder="验证码"
                ></a-input>
                <a-button
                  class="verify-a"
                  type="primary"
                  @click="sendCode()"
                  :disabled="isRunning"
                  >{{
                    isRunning ? initialNum + "s以后重新发送" : "发送验证码"
                  }}</a-button
                >
              </div>

              <div class="u-reg-err-tips">{{ error.codeText }}</div>
            </div>
          </div>
        </div>

        <!--字段内嵌结构-->
        <div v-if="extraItem.extras('formfield.model') == 'style2'">
          <div class="tab-input">
            <div class="must style2-wap">
              <div class="m-input-content">
                <div class="opacityText">
                  {{ identityPlaceholder || identityPlaceholderDefault }}
                </div>
                <a-input
                  v-model="identity"
                  class="verify-input status-input"
                  :class="{ err: error.identityText }"
                ></a-input>
                <div class="u-label" :class="{ moved: identity }">
                  {{ identityPlaceholder || identityPlaceholderDefault }}
                </div>
              </div>
              <div
                v-if="isShowPhoneTips"
                style="color: #cacaca; font-size: 3.2vw; margin-top: 1vw"
              >
                手机号请填写区号，如86
              </div>
              <div class="u-reg-err-tips">{{ error.identityText }}</div>
            </div>
          </div>
          <div
            class="tab-input"
            v-if="extras.verifySet"
            :style="{
              display:
                extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
            }"
          >
            <div class="must style2-wap">
              <div class="m-input-content">
                <div class="opacityText">验证码</div>
                <a-input
                  class="verify-input status-input"
                  v-model="code"
                  :class="{ err: error.codeText }"
                ></a-input>
                <div class="u-label" :class="{ moved: code }">验证码</div>
                <a
                  class="verify-a"
                  type="primary"
                  @click="sendCode()"
                  :disabled="isRunning"
                  >{{
                    isRunning ? initialNum + "s以后重新发送" : "发送验证码"
                  }}</a
                >
              </div>

              <div class="u-reg-err-tips pull-absolute">
                {{ error.codeText }}
              </div>
            </div>
          </div>
        </div>

        <a-button
          class="verify-submit"
          type="primary"
          @click="submitVerify()"
          >{{ extras | extra("verifyButton.text") }}</a-button
        >
        <div class="verify-tip">
          <span
            class=""
            v-if="extras.unSignButton && extras.unSignButton.text != 'hide'"
            :style="{
              color:
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontColor
                  : '',
              'font-size':
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontSize + 'px'
                  : '',
              'font-Weight':
                extras1.unSignButton.text == 'custom'
                  ? extras1.unSignButton.fontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
            >{{
              extras1.unSignButton.text2 == "custom"
                ? extras1.unSignButton.content
                : "尚未报名？"
            }}</span
          >
          <a
            :href="$router.resolve(signUp).href"
            class="u-text-blue"
            v-if="extras.unSignButton && extras.unSignButton.text2 != 'hide'"
            :style="{
              color:
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontColor2
                  : '',

              'font-style':
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontTilt2 == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
              'font-Weight':
                extras1.unSignButton.text2 == 'custom'
                  ? extras1.unSignButton.fontWeight2 == 'on'
                    ? '900'
                    : ''
                  : '',
            }"
            >点击报名</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/BannerNew.vue";
import mixinMeeting from "../../mixin/meetingNew.js";
import mixinConfig from "../../mixin/configNew.js";
import mixin from "../../mixin/form.js";
import mixinVerify from "../../mixin/verifyNew.js";
export default {
  name: "WapVerify",
  mixins: [mixinConfig, mixin, mixinVerify, mixinMeeting],
  data() {
    return {
      platform: "wap",
    };
  },
  computed: {
    extras1() {
      return this.$store.state.extras;
    },
  },
  components: {
    Banner,
  },
};
</script>
